export class TimeIsOutOfSyncError extends Error {
    constructor(timeDifferenceBetweenServerAndClientInMinutes) {
        super(`Time is out of sync on your device by ${timeDifferenceBetweenServerAndClientInMinutes} minutes.`);
        this.name = 'TimeIsOutOfSyncError';
        this.timeDifferenceBetweenServerAndClientInMinutes = timeDifferenceBetweenServerAndClientInMinutes;
    }
}
